import { CustomerTranslation } from 'locales/de/pages/Billing/customer';

const en: CustomerTranslation = {
  heading: 'Customer',
  headingDetailPage: 'Customer overview',
  import: 'Import customers',
  zpId: 'Paymentpartner-ID',
  drawer: {
    createTitle: 'Create new customer',
    editTitle: 'Edit customer'
  },
  alerts: {
    createFailed: 'An error occurred while creating the customer.',
    createSuccess: 'The creation of the customer was successful.',
    updateFailed: 'An error occurred while updating the customer.',
    updateSuccess: 'Updating the customer was successful.',
    uploadSuccess: 'The file was successfully imported.'
  },
  validation: {
    ustId: 'The specified VAT Id is not valid',
    ustIdCharacter: 'A VAT ID consists of 11 characters'
  }
};

export default en;
